export enum EntityType {
    Booking = 10,
}

export enum NoteType {
    ChangeRequest = 17,
    CancelRequest = 18,
}

